import { For, Show } from 'solid-js';
import { actions, stores } from '../state/store';

export function ProjectSelector() {
  return (
    <nav class="project-selector" aria-label="Projects">
      <h2>Projects</h2>
      <Show when={stores.state.projects.length > 0} fallback={<p class="empty">No projects</p>}>
        <ul role="list">
          <For each={stores.state.projects}>
            {(p) => (
              <li>
                <button
                  type="button"
                  classList={{ active: stores.state.activeProjectId === p.id }}
                  onClick={() => void actions.selectProject(p.id)}
                >
                  <span class="name">{p.name}</span>
                  <small class="workspace">{p.workspace}</small>
                </button>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </nav>
  );
}
